export default ({ fill = "#374151", width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_5432_26288)">
      <path
        d="M1.5 12C1.5 6.20156 6.20156 1.5 12 1.5C17.7984 1.5 22.5 6.20156 22.5 12V18.7547C22.5 19.9969 21.4922 21.0047 20.25 21.0047L16.3734 21C16.0641 20.1281 15.2297 19.5 14.25 19.5H11.25C10.0078 19.5 9 20.5078 9 21.75C9 22.9922 10.0078 24 11.25 24H14.25C15.2297 24 16.0641 23.3719 16.3734 22.5L20.25 22.5047C22.3219 22.5047 24.0047 20.8266 24.0047 18.7547V12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12V14.25C0 14.6625 0.3375 15 0.75 15C1.1625 15 1.5 14.6625 1.5 14.25V12ZM15 21.75C15 22.1625 14.6625 22.5 14.25 22.5H11.25C10.8375 22.5 10.5 22.1625 10.5 21.75C10.5 21.3375 10.8375 21 11.25 21H14.25C14.6625 21 15 21.3375 15 21.75ZM6.75 10.5H7.5V16.5H6.75C5.50781 16.5 4.5 15.4922 4.5 14.25V12.75C4.5 11.5078 5.50781 10.5 6.75 10.5ZM3 12.75V14.25C3 16.3219 4.67812 18 6.75 18H7.5C8.32969 18 9 17.3297 9 16.5V10.5C9 9.67031 8.32969 9 7.5 9H6.75C4.67812 9 3 10.6781 3 12.75ZM16.5 10.5H17.25C18.4922 10.5 19.5 11.5078 19.5 12.75V14.25C19.5 15.4922 18.4922 16.5 17.25 16.5H16.5V10.5ZM17.25 9H16.5C15.6703 9 15 9.67031 15 10.5V16.5C15 17.3297 15.6703 18 16.5 18H17.25C19.3219 18 21 16.3219 21 14.25V12.75C21 10.6781 19.3219 9 17.25 9Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_5432_26288">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
